<button class="bon-btn-info" *ngIf="showNewLimitButton" (click)="onNewLimit()" translate>inquiry.newLimitButton.title</button>